export var AssetFolderModels;
(function (AssetFolderModels) {
    class AssetFolder {
        constructor(data) {
            this.id = data.id;
            this.name = data.name;
            this.externalId = data.externalId;
            this.folders = data.folders;
            this.codename = data.codename;
            this._raw = data._raw;
        }
    }
    AssetFolderModels.AssetFolder = AssetFolder;
})(AssetFolderModels || (AssetFolderModels = {}));
//# sourceMappingURL=asset-folder.models.js.map